<template>
     <div class="loader-wrapper"  :class="{'loderhide' : !show }">
      <div class="loader bg-white">
        <div class="whirly-loader"> </div>
      </div>
    </div>
</template>

<script>
  // import Userauth from '../auth/js/index'
  
  export default {
    data(){
      return{
        show: true
      };
    },
    mounted() {
      // this.timeOut()
      // Userauth.handleAuthentication().then(() =>{
      //   window.location.href = '/'
      // })
      let id_token = this.$route.hash ? this.$route.hash.split('id_token=')[1] : ''
      console.log(id_token)
    },
    methods: {
      timeOut(){
        var self = this;
        setTimeout(function(){
          self.show = false;
        }, 1000);
      }
    }
  };
</script>

<style lang="scss" scoped>
.loader-wrapper.loderhide {
  display: none;
}
</style>
